import React from 'react';
import clsx from 'clsx';
import { LabeledSelect } from '@nextiva/next-ui';

import styles from './LabeledMultiSelect.scss';

export default (props) => (
  <LabeledSelect
    {...props}
    closeOnSelect={props.closeOnSelect || false}
    className={clsx(props.className, styles.multiSelectTempFix)}
  />
);
